import PageView from './PageView'

export default PageView
